export default function (lote) {
  let window, title
  if (typeof lote !== 'undefined' && lote) {
    window = lote.id ? `lote.${lote.id}` : 'lote.new'
    title = 'Visualizar Lote'
  } else {
    window = 'lote.new'
    title = 'Novo Lote'
  }

  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: title,
    width: '1100',
    height: '90%',
    minWidth: '1000px',
    minHeight: '500px',
    backdrop: true,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
      __lote: lote
    }
  }, () => import('../components/window/Lote.vue'))
    .then((wid) => {
      console.log(wid)
      this.$uloc.window.listen(wid, {
        loaded: (wid, lote) => {
          console.log('Loaded lote event')
        }
      })
      this.windowLoteEvents && this.windowLoteEvents(wid)
    }) // return wid
}
